import React, { useState } from "react";
import svnlogo from '../images/svnlogo.jpg';
import { Link, useNavigate } from "react-router-dom";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";

const Header = () => {
    const navigate = useNavigate();

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [openSubMenu, setOpenSubMenu] = useState(null);

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const toggleSubMenu = (menu) => {
        setOpenSubMenu(openSubMenu === menu ? null : menu);
    };

    return (
        <>
            <header>
                <nav className=" bg-white border-gray-200 shadow-md px-4 lg:px-6 py-2.5 dark:bg-gray-800">
                    <div className="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">
                        <Link to={'/'}>
                        <span className="flex items-center cursor-pointer" >
                            <img src={svnlogo} className="mr-3 rounded-full w-14 " alt="svn Logo" />
                            <span class="self-center text-xl font-bold whitespace-nowrap text-green-500">SVN</span>
                        </span>
                        </Link>
                       
                        <div className="flex items-center lg:order-2">
                            <span onClick={() => {
                                navigate('/contact')
                            }} className="bg-green-500 text-white rounded-full py-2 px-4 font-medium cursor-pointer">Get Started</span>
                            <button onClick={toggleDrawer} data-collapse-toggle="mobile-menu-2" type="button" className="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="mobile-menu-2" aria-expanded="false">
                                <span className="sr-only">Open main menu</span>
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
                                <svg className="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                            </button>
                        </div>
                        <div className="hidden justify-between items-center w-full lg:flex lg:w-auto lg:order-1" id="mobile-menu-2">
                            <ul className="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0">
                                <li onClick={() => {
                                    navigate('/')
                                }} className="cursor-pointer">
                                    <span className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700 hover:text-green-500">Home</span>
                                </li>
                                <li onClick={() => {
                                    navigate('/about')
                                }} className="cursor-pointer">
                                    <span className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700 hover:text-green-500">About-Us</span>
                                </li>
                                <li className="relative group">
                                    <a href="#" className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700 hover:text-green-500">
                                        Facilities
                                    </a>

                                    <ul className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 shadow-lg rounded-lg opacity-0 invisible transition-opacity duration-300 group-hover:opacity-100 group-hover:visible group-hover:delay-0 delay-1000 dark:bg-gray-800 dark:border-gray-700 z-30">
                                        <li onClick={() => {
                                            navigate('/smart-classroom')
                                        }}><span className="block px-4 py-2 cursor-pointer text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 hover:text-green-500">Smart classrooms</span></li>
                                        <li onClick={() => {
                                            navigate('/science-lab')
                                        }}><span className="block px-4 py-2 cursor-pointer text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 hover:text-green-500">Science Lab</span></li>
                                        <li onClick={() => {
                                            navigate('/computer-lab')
                                        }}><span className="block px-4 py-2 cursor-pointer text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 hover:text-green-500">Computer Lab</span></li>
                                        <li onClick={() => {
                                            navigate('/yoga')
                                        }}><span className="block px-4 py-2 cursor-pointer text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 hover:text-green-500">Yoga</span></li>
                                        <li onClick={() => {
                                            navigate('/van-facility')
                                        }}><span className="block px-4 py-2 cursor-pointer text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 hover:text-green-500">Van facility</span></li>
                                        <li onClick={() => {
                                            navigate('/sports')
                                        }}><span className="block px-4 py-2 cursor-pointer text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 hover:text-green-500">Sports</span></li>
                                    </ul>
                                </li>


                                <li className="relative group">
                                    <a href="#" className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700 hover:text-green-500">
                                        Programmes
                                    </a>

                                    <ul className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 shadow-lg rounded-lg opacity-0 invisible transition-opacity duration-300 group-hover:opacity-100 group-hover:visible group-hover:delay-0 delay-1000 dark:bg-gray-800 dark:border-gray-700 z-30">
                                        <li onClick={() => {
                                            navigate('/pre-primary')
                                        }}><span className="block px-4 py-2 cursor-pointer text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 hover:text-green-500">Pre Primary</span></li>
                                        <li onClick={() => {
                                            navigate('/primary')
                                        }}><span className="block px-4 py-2 cursor-pointer text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 hover:text-green-500">Primary</span></li>
                                        <li onClick={() => {
                                            navigate('/high-school')
                                        }}><span className="block px-4 py-2 cursor-pointer text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 hover:text-green-500">High school</span></li>
                                    </ul>
                                </li>

                                <li onClick={() => {
                                    navigate('/gallery')
                                }} className="cursor-pointer">
                                    <span className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700 hover:text-green-500" >Gallery</span>
                                </li>
                                <li onClick={() => {
                                    navigate('/contact')
                                }} className="cursor-pointer">
                                    <span className="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0 dark:text-gray-400 lg:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white lg:dark:hover:bg-transparent dark:border-gray-700 hover:text-green-500">Contact</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>

            {/* Drawer (Sidebar) */}
            <div
                className={`fixed top-0 right-0 w-64 h-full bg-white shadow-lg transform ${isDrawerOpen ? "translate-x-0" : "translate-x-full"
                    } transition-transform duration-300 ease-in-out z-50`}
            >
                {/* Drawer Header */}
                <div className="flex justify-between items-center p-4 border-b">
                    <span className="text-xl font-bold text-green-500">Menu</span>
                    <button onClick={toggleDrawer} className="text-gray-500 text-2xl">
                        <FaTimes />
                    </button>
                </div>
                {/* Drawer Menu */}
                <ul className="flex flex-col p-4">
                    <li onClick={() => {
                        toggleDrawer();
                        navigate("/");
                    }}
                        className="cursor-pointer py-2 hover:text-green-500">
                        Home
                    </li>
                    <li onClick={() => {
                        toggleDrawer();
                        navigate("/about");
                    }} className="cursor-pointer py-2 hover:text-green-500">
                        About Us
                    </li>

                    {/* Facilities Dropdown */}
                    <li className="relative">
                        <button
                            onClick={() => toggleSubMenu("facilities")}
                            className="flex justify-between items-center w-full py-2 hover:text-green-500"
                        >
                            Facilities <FaChevronDown />
                        </button>
                        <ul className={`overflow-hidden transition-all duration-300 ${openSubMenu === "facilities" ? "max-h-60" : "max-h-0"}`}>
                            <li onClick={() => {
                                toggleDrawer();
                                navigate('/smart-classroom')
                            }} className="pl-4 py-2  hover:text-green-500">Smart Classrooms</li>
                            <li onClick={() => {
                                toggleDrawer();
                                navigate('/science-lab')
                            }} className="pl-4 py-2 hover:text-green-500">Science Lab</li>
                            <li onClick={() => {
                                toggleDrawer();
                                navigate('/computer-lab')
                            }} className="pl-4 py-2 hover:text-green-500">Computer Lab</li>
                            <li onClick={() => {
                                toggleDrawer();
                                navigate('/yoga')
                            }} className="pl-4 py-2 hover:text-green-500">Yoga</li>
                            <li onClick={() => {
                                toggleDrawer();
                                navigate('/van-facility')
                            }} className="pl-4 py-2 hover:text-green-500">Van Facility</li>
                            <li onClick={() => {
                                toggleDrawer();
                                navigate('/sports')
                            }} className="pl-4 py-2 hover:text-green-500">Sports</li>
                        </ul>
                    </li>

                    {/* Programmes Dropdown */}
                    <li className="relative">
                        <button
                            onClick={() => toggleSubMenu("programmes")}
                            className="flex justify-between items-center w-full py-2 hover:text-green-500"
                        >
                            Programmes <FaChevronDown />
                        </button>
                        <ul className={`overflow-hidden transition-all duration-300 ${openSubMenu === "programmes" ? "max-h-40" : "max-h-0"}`}>
                            <li onClick={() => {
                                toggleDrawer();
                                navigate('/pre-primary')
                            }} className="pl-4 py-2 hover:text-green-500">Pre Primary</li>
                            <li onClick={() => {
                                toggleDrawer();
                                navigate('/primary')
                            }} className="pl-4 py-2 hover:text-green-500">Primary</li>
                            <li onClick={() => {
                                toggleDrawer();
                                navigate('/high-school')
                            }} className="pl-4 py-2 hover:text-green-500">High School</li>
                        </ul>
                    </li>

                    <li onClick={() => {
                        toggleDrawer();
                        navigate("/gallery");
                    }} className="cursor-pointer py-2 hover:text-green-500">
                        Gallery
                    </li>
                    <li onClick={() => {
                        toggleDrawer();
                        navigate("/contact");
                    }} className="cursor-pointer py-2 hover:text-green-500">
                        Contact
                    </li>
                </ul>
            </div>

            {/* Overlay */}
            {isDrawerOpen && (
                <div
                    onClick={toggleDrawer}
                    className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-40"
                ></div>
            )}
        </>
    )
}

export default Header;